<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Ataskaitų siuntimo administravimas</h3>

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :page.sync="page"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.atr_ijungta`]="{ item }">
        <el-switch v-model="item.atr_ijungta" />
      </template>
      <template #[`item.atr_ijungta_text`]="{ item }">
        <el-busena
          :busena="item.atr_ijungta_text"
          :color="item.atr_ijungta_color"
        />
      </template>
      <template #[`item.pastasList`]="{ item }">
        <el-button class="mt-2 mb-3" x-small @click.native="addItem(item)">
          Pridėti el. paštą
        </el-button>
        <div
          class="pastas"
          v-for="(pastas, index) in item.atr_el_pastai"
          :key="index"
        >
          <el-pastas
            class="my-0 py-0"
            :validate-key="`${item.atr_id}-${index}`"
            :hide-details="true"
            v-model="item.atr_el_pastai[index]"
          />
          <el-table-action
            class="mt-0"
            :item="{ canDelete: true }"
            @deleteItem="deleteItem(item, index)"
          />
        </div>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-footer class="form-footer">
      <el-button primary @click.native="saveData()" :loading="loading"
        >Saugoti</el-button
      >
      <el-button @click.native="cancelData()" :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
    </v-footer>
  </v-container>
</template>

<script>
import unsavedData from '../../mixins/unsavedData'
import print from '../../mixins/print'

export default {
  name: 'AdminParametrai',
  mixins: [unsavedData, print],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: [],
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      page: 1,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Aktyvus',
          align: 'start',
          sortable: true,
          value: 'atr_ijungta',
        },
        {
          text: 'Susijusio registro objektas',
          align: 'start',
          sortable: true,
          value: 'atr_registras',
        },
        {
          text: 'Siuntimas',
          align: 'start',
          sortable: true,
          value: 'atr_ijungta_text',
        },
        {
          text: 'El. paštas',
          align: 'start',
          sortable: true,
          value: 'pastasList',
        },
        {
          text: 'Pakeitimo data',
          align: 'start',
          sortable: true,
          value: 'atr_atnaujinimo_data',
        },
        {
          text: 'Pakeitimą atlikęs asmuo',
          align: 'start',
          sortable: true,
          value: 'busena_pakeite',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.formData.map((item, index) => {
        item.atr_ijungta_text = item.atr_ijungta ? 'Įjungtas' : 'Išjungtas'
        item.atr_ijungta_color = item.atr_ijungta ? 'green' : 'default'
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isSearch() {
      return this.search != null && this.search.length > 0
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`admin/ataskaita/registras`)
        .then(res => {
          this.formData = res.data.registrai
          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true

          let data = {
            registrai: this.formData,
          }

          this.$axios
            .post(`admin/ataskaita/registras`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              if (toRoute) {
                this.goToRoute()
              } else {
                this.getData()
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    addItem(item) {
      item.atr_el_pastai.push('')
    },
    deleteItem(item, index) {
      item.atr_el_pastai.splice(index, 1)
      // this.formData = this.formData.map((item, index) => {
      //   item.index = index
      //   return item
      // })
    },
  },
}
</script>
<style lang="scss" scoped>
.pastas {
  width: 100%;
  display: inline-flex;
  white-space: nowrap;
  align-items: flex-start;
  line-height: 40px;
}
</style>
